(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5316],{

/***/ 99803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _shopify_react_idle__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17548);
/* harmony import */ var _lib_handleError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67408);
/* harmony import */ var _fh_components_fh_js_api_core_store_slices_categoriesSlice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11012);
/* harmony import */ var _layouts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75842);
/* harmony import */ var _seo_Ecommerce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31893);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var NextNewsItemPage = function NextNewsItemPage(props) {
  var setPageType = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function () {
    _seo_Ecommerce__WEBPACK_IMPORTED_MODULE_6__/* ["default"].setPageType */ .ZP.setPageType(_seo_Ecommerce__WEBPACK_IMPORTED_MODULE_6__/* ["default"].PAGE_TYPES.SPECIAL */ .ZP.PAGE_TYPES.SPECIAL);
  }, []);
  (0,_shopify_react_idle__WEBPACK_IMPORTED_MODULE_8__/* .useIdleCallback */ .Y)(setPageType);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_layouts__WEBPACK_IMPORTED_MODULE_5__/* .TextPage */ .xU, _objectSpread({}, props));
};

NextNewsItemPage.getInitialProps = /*#__PURE__*/function () {
  var _ref2 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_ref) {
    var query, reduxStore, slug, access, data, textPageType, redirectTo;
    return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = _ref.query, reduxStore = _ref.reduxStore;
            slug = query.slug, access = query.access;
            textPageType = 'special_offer';
            redirectTo = null;
            _context.next = 6;
            return reduxStore.dispatch((0,_fh_components_fh_js_api_core_store_slices_categoriesSlice__WEBPACK_IMPORTED_MODULE_4__/* .getCategoryTreeBySlug */ .P1)({
              slug: "/".concat(slug),
              onSuccess: function onSuccess(result) {
                if (result.page.pageType === 'redirect') {
                  textPageType = 'redirect';
                  redirectTo = result.page.data.to;
                }

                data = result.page.data.page;
              },
              onError: function onError(result) {
                (0,_lib_handleError__WEBPACK_IMPORTED_MODULE_3__/* .handleError */ .S)(result);
              }
            }));

          case 6:
            return _context.abrupt("return", {
              slug: slug,
              textPageType: textPageType,
              access: access,
              data: data,
              redirectTo: redirectTo
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["default"] = (NextNewsItemPage);

/***/ }),

/***/ 95586:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special-offers/[slug]",
      function () {
        return __webpack_require__(99803);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17548:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ useIdleCallback; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@shopify/react-idle/build/esm/types.mjs
let UnsupportedBehavior;

(function (UnsupportedBehavior) {
  UnsupportedBehavior[UnsupportedBehavior["Immediate"] = 0] = "Immediate";
  UnsupportedBehavior[UnsupportedBehavior["AnimationFrame"] = 1] = "AnimationFrame";
})(UnsupportedBehavior || (UnsupportedBehavior = {}));



;// CONCATENATED MODULE: ./node_modules/@shopify/react-idle/build/esm/hooks.mjs



function useIdleCallback(callback, {
  unsupportedBehavior = UnsupportedBehavior.AnimationFrame
} = {}) {
  const handle = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    if ('requestIdleCallback' in window) {
      handle.current = window.requestIdleCallback(() => callback());
    } else if (unsupportedBehavior === UnsupportedBehavior.AnimationFrame) {
      handle.current = window.requestAnimationFrame(() => {
        callback();
      });
    } else {
      callback();
    }

    return () => {
      const {
        current: currentHandle
      } = handle;
      handle.current = null;

      if (currentHandle == null) {
        return;
      }

      if ('cancelIdleCallback' in window) {
        window.cancelIdleCallback(currentHandle);
      } else if (unsupportedBehavior === UnsupportedBehavior.AnimationFrame) {
        window.cancelAnimationFrame(currentHandle);
      }
    };
  }, [callback, unsupportedBehavior]);
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(95586); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);